/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DenoiseInputs */

const cs_enum_denoise = /** @type {(inputs: Enum_DenoiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odšumění`)
};

const en_enum_denoise = /** @type {(inputs: Enum_DenoiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denoise`)
};

/**
* | output |
* | --- |
* | "Denoise" |
*
* @param {Enum_DenoiseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_denoise = /** @type {((inputs?: Enum_DenoiseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DenoiseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_denoise(inputs)
	return cs_enum_denoise(inputs)
});